import { connect } from 'react-redux'
import RidersTable from '../../components/riders/RidersTable'
import * as actions from '../../state/actions/riders'
import { getRidersList } from '../../state/reducers/riders'
import { IRiderObject, IStoreState, IRiderFilters } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    orgId: state.organizations.currentOrgId,
    searchQuery: state.riderSearch.query,
    riders: getRidersList(state.riders),
    totalItems: state.riders.metadata.total,
    deactivatedRiderId: state.riders.deactivatedRiderId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchRiders: (filters: IRiderFilters) => {
      return dispatch(actions.getMany(filters))
    },
    moveToActive: (rider: IRiderObject) => {
      console.log('restoring rider')
      return dispatch(actions.restoreArchiveRider(rider))
    },
    moveToArchive: (rider: IRiderObject) => {
      console.log('archiving rider')
      return dispatch(actions.archiveRider(rider))
    },
    activate: (rider: IRiderObject) => {
      dispatch(actions.activateRider(rider))
    },
    deactivate: (rider: IRiderObject) => {
      dispatch(actions.deactivateRider(rider))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RidersTable)



// WEBPACK FOOTER //
// ./src/containers/riders/RidersTable.ts